import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatNumber } from 'utils/formats';
import { TradingOffer, TradingOfferStatus } from '../../../types/TradingOffer';

type TradingOfferStatusBannerProps = {
  offer: TradingOffer;
  offerStatus: TradingOfferStatus;
};

const TradingOfferStatusBanner: FC<TradingOfferStatusBannerProps> = ({
  offer,
  offerStatus,
}) => {
  const { t } = useTranslate();

  const agreedShares = offer.sharesCount.agreed;
  const totalShares = offer.sharesCount.total;
  const isPartiallyAccepted = agreedShares > 0 && agreedShares < totalShares;

  if (offerStatus === 'EXPIRED') {
    return (
      <div className="alert alert-warning alert-icon">
        <em className="icon ni ni-alert-circle" />
        <strong>{t('ExpiredOffer')}</strong>. {t('ExpiredOfferDescription')}
      </div>
    );
  }

  if (offerStatus === 'ACCEPTED') {
    return (
      <div className="alert alert-success alert-icon">
        <em className="icon ni ni-check-circle" />
        <strong>{t('FullyAccepted')}</strong>.{' '}
        {t('FullyAcceptedDescription', {
          total: formatNumber(totalShares),
        })}
      </div>
    );
  }

  if (isPartiallyAccepted) {
    return (
      <div className="alert alert-info alert-icon">
        <em className="icon ni ni-info" />
        <strong>{t('PartiallyAccepted')}</strong>.{' '}
        {t('PartiallyAcceptedDescription', {
          agreed: formatNumber(agreedShares),
          total: formatNumber(totalShares),
        })}
      </div>
    );
  }

  return null;
};

export default TradingOfferStatusBanner;
